import { useAddressTransformer } from '@checkout/composables/useAddressTransformer';
import { getFormattedAddressData } from '@checkout/helpers';
import { useCartStore, useCheckoutStore } from '@checkout/stores';
import { computed } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';

import { AddressTypeEnum } from '~/models';

export function useShippingComplete() {
  const checkoutStore = useCheckoutStore();
  const { shippingData } = storeToRefs(checkoutStore);
  const cartStore = useCartStore();
  const { hasOnlyBooxiItemsInCart, billingAddress } = storeToRefs(cartStore);
  const { cartAddressToAddress } = useAddressTransformer();

  const selectedShippingAddress = computed<string>(() => {
    if (!shippingData.value && !billingAddress.value) return '';

    const parts: string[] = hasOnlyBooxiItemsInCart.value
      ? getFormattedAddressData(cartAddressToAddress(billingAddress.value, AddressTypeEnum.BILLING))
      : getFormattedAddressData(cartAddressToAddress(shippingData.value, AddressTypeEnum.SHIPPING));
    return parts.join(', ');
  });

  const selectedShippingMethod = computed<string>(() => {
    const method = shippingData.value?.selected_shipping_method;

    return !method || hasOnlyBooxiItemsInCart.value ? '' : method.method_title;
  });

  return {
    selectedShippingAddress,
    selectedShippingMethod
  };
}
